import { useEffect } from 'react';
import { useBreadcrumbs } from '../context/BreadcrumbContext';

/**
 * Give a detail page a breadcrumb trail with names instead of ids:
 *
 *   useDetailBreadcrumbs(account ? [{ label: 'Accounts', path: '/accounts' }, { label: account.name }] : null);
 *
 * Pass null until the record has loaded (the automatic trail shows meanwhile).
 * Cleared when the page unmounts.
 */
export default function useDetailBreadcrumbs(items) {
  const { setBreadcrumbs, clearBreadcrumbs } = useBreadcrumbs();
  // Compare by value: callers build the array on every render.
  const key = JSON.stringify(items || null);

  useEffect(() => {
    const parsed = key === 'null' ? null : JSON.parse(key);
    if (parsed) setBreadcrumbs(parsed);
    return () => clearBreadcrumbs();
  }, [key, setBreadcrumbs, clearBreadcrumbs]);
}
